import React from 'react';
import { Nav } from 'react-bootstrap';
import { useNavigate, useLocation } from "react-router";
import { useParams } from 'react-router-dom';
import groupIcon from '../../Asset/Images/Group.svg';


function SubHeader() {
  const { templateId } = useParams();
  const location = useLocation()
  const navigate = useNavigate();

  return (
    <>
      <div class="box-wts-chart">
        <div className='left-menu-side'>
          <div className='items-txtwm-lst-1'><span className="lst-rwm--emt">Full-Site</span></div>
          <ul className="tab-list-wgtItems ul-rowfrm-wm-1 d-flex flex-wrap ps-0 mb-0">
            <li style={{display: (templateId && !location.pathname.includes('deploy')? 'none' : '')  }} className='items-wt-list nav-item'>
              <span onClick={() => navigate('/template/deploy')} className={`btn-tab-items nav-link ${location.pathname.includes('deploy') || location.pathname == '/' ? 'active' : ''}`} eventKey="tabItem1"><img
                className={`nav-img ${location.pathname === '/template/deploy' ? 'active-icon' : ''}`}
                src={groupIcon}
                alt="icon"
              />Deploy</span>
            </li>
            <li style={{display: (templateId && !location.pathname.includes('release')? 'none' : '')  }}  className='items-wt-list'>
              <span onClick={() => navigate('/template/release')} className={`btn-tab-items nav-link ${location.pathname.includes('release') ? 'active' : ''}`} eventKey="tabItem2"><img
                className={`nav-img ${location.pathname === '/template/release' ? 'active-icon' : ''}`}
                src={groupIcon}
                alt="icon"
              />RELEASE</span>
            </li>
            {/* 
            <li className='items-wt-list'>
              <span onClick = {() => navigate('/dashboard')} className={`btn-tab-items nav-link ${location.pathname.includes('raship') ? 'active' : ''}`} eventKey="tabItem7">DASHBOARD</span>
            </li> */}
          </ul>
        </div>
        <div className='right-menu-side'>
          <div className='items-txtwm-lst-1'><span className="lst-singlr-emt">Single Assets</span></div>
          <ul className="tab-list-wgtItems ul-rowfrm-wm-2 d-flex flex-wrap mb-0 ps-0">
            <li style={{display: (templateId && !location.pathname.includes('add')? 'none' : '')  }} className='items-wt-list'>
              <span onClick={() => navigate('/template/add')} className={`btn-tab-items nav-link ${location.pathname.includes('add') ? 'active' : ''}`} eventKey="tabItem3"><img
                className={`nav-img ${location.pathname === '/template/add' ? 'active-icon' : ''}`}
                src={groupIcon}
                alt="icon"
              />ADD</span>
            </li>
            <li style={{display: (templateId && !location.pathname.includes('return')? 'none' : '')  }} className='items-wt-list'>
              <span onClick={() => navigate('/template/return')} className={`btn-tab-items nav-link ${location.pathname.includes('return') ? 'active' : ''}`} eventKey="tabItem4"><img
                className={`nav-img ${location.pathname === '/template/return' ? 'active-icon' : ''}`}
                src={groupIcon}
                alt="icon"
              />RETURN</span>
            </li>
            <li style={{display: (templateId && !location.pathname.includes('swap')? 'none' : '')  }}  className='items-wt-list'>
              <span onClick={() => navigate('/template/swap')} className={`btn-tab-items nav-link ${location.pathname.includes('swap') ? 'active' : ''}`} eventKey="tabItem5"><img
                className={`nav-img ${location.pathname === '/template/swap' ? 'active-icon' : ''}`}
                src={groupIcon}
                alt="icon"
              />SWAP</span>
            </li>
            <li style={{display: (templateId && !location.pathname.includes('resupply')? 'none' : '')  }}  className='items-wt-list'>
              <span onClick={() => navigate('/template/resupply')} className={`btn-tab-items nav-link ${location.pathname.includes('resupply') ? 'active' : ''}`} eventKey="tabItem6"><img
                className={`nav-img ${location.pathname === '/template/resupply' ? 'active-icon' : ''}`}
                src={groupIcon}
                alt="icon"
              />RESUPPLY</span>
            </li>
            <li style={{display: (templateId && !location.pathname.includes('status')? 'none' : '')  }}  className='items-wt-list'>
              <span onClick={() => navigate('/template/status')} className={`btn-tab-items nav-link ${location.pathname.includes('status') ? 'active' : ''}`} eventKey="tabItem7"><img
                className={`nav-img ${location.pathname === '/template/status' ? 'active-icon' : ''}`}
                src={groupIcon}
                alt="icon"
              />STATUS CHANGE</span>
            </li>
            {/* 
            <li className='items-wt-list'>
              <span onClick = {() => navigate('/dashboard')} className={`btn-tab-items nav-link ${location.pathname.includes('raship') ? 'active' : ''}`} eventKey="tabItem7">DASHBOARD</span>
            </li> */}
          </ul>
        </div>
      </div>


      
    </>


  );
}

export default SubHeader;